import TableCardSwitch from "./TableCardSwitch";

export default TableCardSwitch;
